import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Mask,
  Path,
  RadialGradient,
  Stop,
} from 'react-native-svg'

const BrandBenifits = ({
  isIconSmall,
  ...props
}: {
  isIconSmall?: boolean
}) => {
  if (isIconSmall) {
    return (
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={29}
        height={29}
        fill="none"
        {...props}
      >
        <Mask
          id="a"
          width={29}
          height={29}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'luminance',
          }}
        >
          <Path
            fill="#fff"
            d="M23.997.808H5.331A4.667 4.667 0 0 0 .664 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.666a4.667 4.667 0 0 0 4.667-4.667V5.474A4.667 4.667 0 0 0 23.997.808Z"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            fill="#F2F7FF"
            d="M23.997.808H5.331A4.667 4.667 0 0 0 .664 5.474v18.667a4.667 4.667 0 0 0 4.667 4.667h18.666a4.667 4.667 0 0 0 4.667-4.667V5.474A4.667 4.667 0 0 0 23.997.808Z"
          />
          <Path
            fill="url(#b)"
            fillRule="evenodd"
            d="m12.946 29.293 1.126-5.098-1.126-4.829h-2.3l-2.817-.242-.563 2.125v7.045c0 .55.45.999 1 .999h4.68Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#c)"
            fillRule="evenodd"
            d="M22.347 28.294v-8.369a.561.561 0 0 0-.559-.558h-5.121l-1.339 4.964 1.339 4.962h4.68c.55 0 1-.45 1-.999Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#d)"
            fillRule="evenodd"
            d="M12.938 19.367h3.74v9.926h-3.74v-9.926Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#e)"
            fillRule="evenodd"
            d="m24.4 17.613.303-.375c.063-.073.058-.094-.034-.118L24.2 17c-.052-.014-.055-.028-.081-.073l-.237-.408c-.049-.083-.078-.083-.126 0l-.238.409c-.025.044-.029.059-.081.072l-.47.12c-.091.024-.096.045-.033.118l.302.375c.033.04.037.087.033.144l-.037.463c-.01.097.01.108.097.072l.413-.177a.22.22 0 0 1 .154 0l.412.177c.088.036.107.025.097-.072l-.036-.463c-.005-.057 0-.104.033-.144Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#f)"
            fillRule="evenodd"
            d="m11.293 15.594-2.16-2.722c-6.915-4.448-8.652 5.17-1.174 3.57l3.334-.848Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#g)"
            fillRule="evenodd"
            d="M13.804 12.439c4.184-6.394-5.42-8.236-3.757-.189l1.83 2.567 1.927-2.378Z"
            clipRule="evenodd"
          />
          <Path
            fill="#fff"
            d="M7.99 14.713a.409.409 0 0 1-.141-.011c-.604-.158-1.076-.241-1.98-.256a.408.408 0 1 1 .014-.815c.873.014 1.42.086 2.172.282a.408.408 0 0 1-.065.8ZM11.868 12.11a.408.408 0 0 1-.446-.4c-.009-.666.215-1.62.532-2.27a.408.408 0 0 1 .733.358c-.26.531-.457 1.366-.45 1.9a.408.408 0 0 1-.369.412Z"
          />
          <Path
            fill="url(#h)"
            fillRule="evenodd"
            d="m8.789 15.876 2.604-.75 1.542-2.092-.645-.938a1.145 1.145 0 0 0-1.586-.295l-.657.45-.906.62-.701.483a1.137 1.137 0 0 0-.296 1.583l.645.94Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#i)"
            fillRule="evenodd"
            d="m6.25 21.61 4.4-3.017-.048-1.945-1.818-.771-.822.565-3.577 2.451a.8.8 0 0 0-.207 1.11l.961 1.4c.248.361.75.454 1.112.206Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#j)"
            fillRule="evenodd"
            d="m12.624 12.598-.343-.502a1.146 1.146 0 0 0-1.586-.295l-.657.45-.624.428a1.146 1.146 0 0 1 1.586.295l.645.94 1.28-.88-.3-.436Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#k)"
            fillRule="evenodd"
            d="m17.484 13.907-2.69 1.843-1.684-.784-.18-1.932.869-.595 3.53-2.42a.803.803 0 0 1 1.116.206l.96 1.399a.802.802 0 0 1-.208 1.111l-1.761 1.208a.892.892 0 0 0 .048-.036Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#l)"
            fillRule="evenodd"
            d="m14.784 15.75-1.865-2.716-4.146 2.842 1.865 2.717 4.146-2.843Z"
            clipRule="evenodd"
          />
          <Path
            fill="url(#m)"
            fillRule="evenodd"
            d="m22.177 14.25.716-.487c.145-.092.148-.13-.001-.217l-.766-.443c-.086-.05-.084-.077-.109-.166l-.215-.815c-.043-.166-.095-.18-.22-.064l-.618.575c-.067.062-.08.086-.18.082l-.885-.034c-.17-.007-.19.028-.116.183l.347.793c.037.085.022.167-.013.261l-.293.772c-.065.158-.036.188.135.17l.812-.091a.41.41 0 0 1 .27.077l.638.512c.135.106.175.096.204-.073l.166-.808c.02-.099.05-.176.128-.228Z"
            clipRule="evenodd"
          />
        </G>
        <Defs>
          <RadialGradient
            id="b"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-5.74723 9.20965 -7.69327 -4.80094 13.554 19.786)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="c"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-5.92678 8.9898 -7.68357 -5.0656 21.813 20.013)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="d"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(109.47 .987 15.667) scale(9.86813 5.41682)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="e"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-1.63002 1.7378 -1.51465 -1.4207 24.451 16.568)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="f"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(140.886 3.096 7.619) scale(8.16393 7.01896)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="g"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-3.66316 7.46391 -6.17973 -3.0329 14.286 7.24)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="h"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(134.561 3.54 8.402) scale(5.85223 5.03731)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="i"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(133.396 1.544 10.223) scale(7.64937 7.0539)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="j"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="matrix(-2.82896 2.46091 -2.03715 -2.34182 12.247 11.653)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="k"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(132.857 7.217 9.184) scale(7.56787 6.99457)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#9DC2FF" />
            <Stop offset={1} stopColor="#3D7FEB" />
          </RadialGradient>
          <RadialGradient
            id="l"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(131.263 3.792 9.725) scale(7.25859 6.32987)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
          <RadialGradient
            id="m"
            cx={0}
            cy={0}
            r={1}
            gradientTransform="rotate(150.176 9.727 9.28) scale(4.28637 3.74153)"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#FFE0B9" />
            <Stop offset={1} stopColor="#CD9A58" />
          </RadialGradient>
        </Defs>
      </Svg>
    )
  }
  return (
    <Svg
      width={48}
      height={48}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_4356_216)">
        <Mask
          id="a"
          style={{
            maskType: 'luminance',
          }}
          maskUnits="userSpaceOnUse"
          x={0}
          y={0}
          width={48}
          height={48}
        >
          <Path
            d="M39.832.49H8.485A7.837 7.837 0 00.648 8.326v31.347a7.837 7.837 0 007.837 7.837h31.347a7.837 7.837 0 007.837-7.837V8.326A7.837 7.837 0 0039.832.49z"
            fill="#fff"
          />
        </Mask>
        <G mask="url(#a)">
          <Path
            d="M39.832.49H8.485A7.837 7.837 0 00.648 8.326v31.347a7.837 7.837 0 007.837 7.837h31.347a7.837 7.837 0 007.837-7.837V8.326A7.837 7.837 0 0039.832.49z"
            fill="#F2F7FF"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.258 48.325l1.89-8.562-1.89-8.107h-3.864l-4.729-.408-.946 3.57v11.83c0 .922.755 1.677 1.679 1.677h7.86z"
            fill="url(#paint0_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M37.069 46.648V32.594a.943.943 0 00-.94-.938h-8.6l-2.248 8.337 2.248 8.332h7.86c.924 0 1.68-.755 1.68-1.678z"
            fill="url(#paint1_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.258 31.656h6.283v16.67h-6.283v-16.67z"
            fill="url(#paint2_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M40.504 28.712l.508-.631c.105-.122.097-.158-.056-.197l-.789-.202c-.088-.023-.094-.048-.137-.122l-.399-.685c-.08-.14-.13-.14-.21 0l-.4.685c-.043.075-.049.1-.137.122l-.789.202c-.153.039-.161.075-.056.197l.508.63c.055.068.062.146.055.242l-.061.778c-.016.162.016.182.162.12l.694-.297a.37.37 0 01.258 0l.693.298c.146.06.178.041.162-.121l-.06-.779c-.008-.095 0-.173.054-.24z"
            fill="url(#paint3_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.503 25.32l-3.626-4.572C3.263 13.28.347 29.431 12.904 26.744l5.6-1.424z"
            fill="url(#paint4_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.715 20.022c7.026-10.737-9.102-13.83-6.308-.316l3.07 4.31 3.238-3.994z"
            fill="url(#paint5_radial_4356_216)"
          />
          <Path
            d="M12.936 23.841a.683.683 0 01-.236-.019c-1.014-.265-1.806-.404-3.323-.429a.685.685 0 11.022-1.369c1.465.024 2.386.144 3.648.474a.685.685 0 01-.11 1.343zM19.453 19.47a.684.684 0 01-.749-.672c-.016-1.117.36-2.72.893-3.81a.685.685 0 011.23.6c-.435.891-.766 2.293-.754 3.191a.685.685 0 01-.62.691z"
            fill="#fff"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.291 25.795l4.375-1.26 2.588-3.513-1.083-1.576a1.924 1.924 0 00-2.663-.496l-1.103.756-1.522 1.042-1.178.81a1.91 1.91 0 00-.83 1.602c.002.365.111.733.333 1.056l1.083 1.579z"
            fill="url(#paint6_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.035 35.421l7.386-5.065-.08-3.265-3.052-1.296-1.381.949L6.9 30.86a1.345 1.345 0 00-.346 1.864l1.613 2.352a1.35 1.35 0 001.868.345z"
            fill="url(#paint7_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.743 20.288l-.577-.841a1.924 1.924 0 00-2.663-.496l-1.103.756-1.048.718a1.924 1.924 0 012.662.496l1.083 1.578 2.151-1.477-.505-.733z"
            fill="url(#paint8_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M28.899 22.487l-4.517 3.096-2.83-1.316-.302-3.245 1.46-.999 5.926-4.064a1.348 1.348 0 011.875.345l1.613 2.35c.417.609.26 1.447-.349 1.866l-2.958 2.029c.028-.02.055-.04.082-.062z"
            fill="url(#paint9_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24.375 25.583l-3.131-4.561-6.963 4.773 3.132 4.561 6.962-4.773z"
            fill="url(#paint10_radial_4356_216)"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.768 23.062l1.202-.816c.244-.155.25-.22-.001-.365l-1.286-.744c-.145-.084-.142-.129-.183-.278l-.362-1.37c-.072-.278-.158-.303-.37-.106l-1.037.965c-.112.105-.135.144-.303.137l-1.484-.057c-.288-.01-.32.047-.196.307l.583 1.333c.062.142.037.28-.022.438l-.492 1.296c-.109.266-.06.317.227.287l1.364-.155a.69.69 0 01.451.13l1.073.86c.227.179.293.162.343-.122l.278-1.358c.034-.165.085-.296.215-.382z"
            fill="url(#paint11_radial_4356_216)"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="paint0_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-9.65136 15.46582 -12.91929 -8.06221 22.28 32.36)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint1_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(123.396 9.27 26.11) scale(18.0822 15.4548)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint2_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(109.47 1.73 25.71) scale(16.5716 9.09646)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint3_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-2.73729 2.91828 -2.54355 -2.3858 40.59 26.956)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint4_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-10.63725 8.64898 -7.43595 -9.14536 16.845 18.574)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint5_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-6.15153 12.53413 -10.37765 -5.09317 23.525 11.292)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint6_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(134.561 5.89 13.58) scale(9.82766 8.45916)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint7_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(-8.8254 9.3339 -8.60728 -8.13836 16.386 26.212)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint8_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(138.98 6.556 13.112) scale(6.29662 5.21234)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint9_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(132.857 12.077 14.888) scale(12.7087 11.746)"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="paint10_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(131.263 6.337 15.796) scale(12.1894 10.6297)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <RadialGradient
          id="paint11_radial_4356_216"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(150.176 16.213 15.088) scale(7.1981 6.28316)"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#CD9A58" />
        </RadialGradient>
        <ClipPath id="clip0_4356_216">
          <Path fill="#fff" d="M0 0H48V48H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default BrandBenifits
